import update from 'external/immutability-helper'
import {zip} from 'external/lodash'
import {
  clsx
 ,styled
 ,React
 ,Box
 ,MenuItem
 ,Select
 ,Table
 ,TableBody
 ,TableRow
 ,TableCell
 ,TableContainer
} from 'external/material'

import useTranslations from 'hooks/translations'
import useAssessment from 'hooks/assessment'

const MatchingContainer = styled(Box)(matchingStyles)

export default function Matching ({question}) {

  const {translate} = useTranslations()
  const {assessment, save} = useAssessment()

  const answer = assessment.answers[question.id] || {}

  async function handleChange(term, definition) {
    const selected = update(answer.selected, {
        [answer.selected.indexOf(definition)]: {$set: -1},
        [term]: {$set: definition},
    })
    const completed = selected.find(i => i == -1) == undefined
    save({[question.id]: {completed: {$set: completed}, selected: {$set: selected}}})
  }

  const terms = answer.terms.map(({term}, index) => {

    return (<>
      <TableCell className={clsx("cell", "selectAnswer")} size="small">
        <SelectDefinition
          index={index}
          definitions={answer.definitions}
          onChange={handleChange}
          value={answer.selected[index]}
        />
      </TableCell>
      <TableCell className={clsx("cell", "termHtml")} dangerouslySetInnerHTML={{__html: term || ''}} />
    </>)
  })

  const definitions = answer.definitions.map(({definition}, index) => {
    const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
    return (<>
      <TableCell className={clsx("cell", "definitionIndex", {selected: answer.selected.indexOf(index) > -1})} size="small">
        {answerIndex})
      </TableCell>
      <TableCell className={clsx("cell", "definitionValue")} dangerouslySetInnerHTML={{__html: definition || ''}} />
    </>)
  })

  return (
  <MatchingContainer className="wrapper">
    <Box className="root">
      <TableContainer component={Box} className="tableContainer">
        <Table className="table">
          <TableBody>{
            zip(terms, definitions).map(([term, definition], index) => {
              return (
                <TableRow key={index} className="pair">
                  {term}
                  {definition}
                </TableRow>
              )
            })}</TableBody>
       </Table>
     </TableContainer>
    </Box>
  </MatchingContainer>
  )
}

function SelectDefinition (props) {

  function handleChange (e) {
    props.onChange(props.index, e.target.value)
  }

  return (
    <Select
      className="termValue"
      value={props.value}
      onChange={handleChange}
    >
      <MenuItem style={{display: 'none'}} value={-1}> </MenuItem>
      {props.definitions.map((definition, index) => {
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
        return (
          <MenuItem key={index} value={index}>{answerIndex}</MenuItem>
        )
      })}
    </Select>
  )
}

function matchingStyles (theme) {
  return {
    "&.wrapper": {
      display: 'flex'
    },
    "& .root": {
      display: 'flex',
      marginTop: 10,
      flexGrow: 1
    },
    "& .tableContainer": {
      flexShrink: 0,
      maxWidth: 1280,
      display: 'flex',
      fontSize: '12pt',
    },
    "& .cell": {
      borderBottom: 0,
      padding: '16px 8px',
      verticalAlign: 'top'
    },
    "& .correctAnswer": {
      width: 35,
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: 35
    },
    "& .selectAnswer": {
      width: 45,
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: 45,
    },
    "& .definitionIndex": {
      width: 20,
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: 20
    },
    "& .termValue": {
      border: 'solid 1px #e0e5e9',
      borderRadius: 3,
      paddingLeft: 8,
      justifyContent: 'center',
      '&:focus': {
        backgroundColor: 'transparent'
      },
      '&:before' : {
        borderBottom: '0 !important'
      },
      '&:after': {
        borderBottom: 0
      }
    },
    "& .termHtml": {
      paddingLeft: 20,
      marginLeft: 20,
      '& > p': {
        margin: 0
      }
    },
    "& .definitionValue": {
      paddingLeft: 20,
      '& > p': {
        margin: 0
      }
    }
  }
}
